module.exports = __webpack_public_path__ + "img/glo.787e6d51.png";